import classNames from 'classnames/bind';
import { VolumeTypeUtils } from 'infra/helpers/volumeTypeUtils';
import React from 'react';
import { formatNum } from 'system/libs/stringHelper';

import { FieldSelect } from './FieldSelect';
import styles from './FieldVolumeType.css';

const css = classNames.bind(styles);

const getVolumeTypeOptions = (volumeTypes, prices) => {
    let ssdPrice, hddPrice, highIopsPrice, priceStrings;
    if (prices) {
        const { ssd, hdd, high_iops_disk } = prices;
        ssdPrice = formatNum(ssd, {
            zeroToFree: false,
            addRoubleSign: true,
            onlyDecimalToFixed: 2,
        });
        hddPrice = formatNum(hdd, {
            zeroToFree: false,
            addRoubleSign: true,
            onlyDecimalToFixed: 2,
        });
        highIopsPrice = formatNum(high_iops_disk, {
            zeroToFree: false,
            addRoubleSign: true,
            onlyDecimalToFixed: 2,
        });

        priceStrings = {
            ssd: ssdPrice,
            hdd: hddPrice,
            highIops: highIopsPrice,
        };
    }

    return volumeTypes.map(({ name }) => ({
        key: name,
        value: name,
        text: `${VolumeTypeUtils.getVolumeTypeName(name)} (${name})`,
        content: (
            <div className={css('itemWrapper')}>
                <div>{`${VolumeTypeUtils.getVolumeTypeName(
                    name,
                )} (${name})`}</div>
                <span className={css('region')}>
                    Регион: {VolumeTypeUtils.getVolumeTypeRegionName(name)}
                </span>
                {prices && (
                    <span className={css('price')}>
                        {getPrice({ name, priceStrings })}
                        ГБ / мес.
                    </span>
                )}
            </div>
        ),
    }));
};

const getPrice = ({ name, priceStrings }) => {
    const physicalDiskType = VolumeTypeUtils.getPhysicalDiskType(name);

    return priceStrings[physicalDiskType];
};

export const FieldVolumeType = ({
    volumeTypes,
    prices,
    label,
    ...otherProps
}) => (
    <FieldSelect
        label={label || 'Тип диска'}
        options={getVolumeTypeOptions(volumeTypes, prices)}
        {...otherProps}
    />
);
